import React from 'react';
import { Button, Modal, message } from 'antd';
import { WeaErrorPage,WeaTools, WeaInput, WeaDialog, WeaRightMenu,WeaRichText,WeaUpload,WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Content_7 from './content/Content_7';
import Content_picture from './content/Content_picture';
import Content_slide from './content/Content_slide';
import Content_dataCenter from './content/Content_dataCenter';
import Content_reportForm from './content/Content_reportForm';
import Content_imgSlide from './content/Content_imgSlide';
import Content_calendar from './content/Content_calendar';
import Content_newNotice from './content/Content_newNotice';
import Content_addWF from './content/Content_addWF';
import Content_contacts from './content/Content_contacts';
import Content_scratchpad from './content/Content_scratchpad';
import Content_weather from './content/Content_weather';
import Content_video from './content/Content_video';
import Content_audio from './content/Content_audio';
import Content_searchengine from './content/Content_searchengine';
import Content_blogStatus from './content/Content_blogStatus';
import Content_task from './content/Content_task';
import Content_16 from './content/Content_16';
import Content_19 from './content/Content_19';
import Content_25 from './content/Content_25';
import Content_flash from './content/Content_flash';


class WeaElementPreview extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            data: {}
        }
        this.getElementStyle = this.getElementStyle.bind(this);
    }
    getElementStyle() {
        const { config ={} } = this.props;
        const { item } = config;
        let params = item;
        const { header } = item;
        if(header){
            let estyle = {};
            const { toolbar ={}, style={}, title='', iconimg={} } = header;
            const { close ={}, lock ={}, more ={}, refresh ={}, setting ={} } = toolbar;
            for(let key in style){
                estyle[key] = style[key]
            }
            params = {
                refreshIconState: refresh.display == '', settingIconState: setting.display == '', closeIconState: close.display == '', moreLocal: more.display == '',
                iconLogo: iconimg.src, iconLock: lock.img, iconRefresh: refresh.img, iconSetting: setting.img, iconClose: close.img, iconMore: more.img,title
            }
            params.style = estyle;
        }
        this.setState({data: params});
    }
    componentWillMount(){
        this.getElementStyle();
    }
    render(){
        const { data } = this.state;
        const { params, config } = this.props;
        const { eid, ebaseid } = config.item;
        const props = {eid, config, params, data};
        let tab4Content=<div></div>;
        switch (ebaseid) {
            case 'picture':     //图片元素预览
                tab4Content=<Content_picture ref={ebaseid} {...props}/>;
            break;
            case 'Slide':   //幻灯片元素预览
                tab4Content=<Content_slide ref={ebaseid} {...props}/>;
                break;
            case 'DataCenter':     //个人中心元素预览
                tab4Content=<Content_dataCenter ref={ebaseid} {...props}/>;
                break;
            case 'reportForm':     //图表元素预览
                tab4Content=<Content_reportForm ref={ebaseid} {...props}/>;
                break;
            case 'imgSlide':     //多图元素预览
                tab4Content=<Content_imgSlide ref={ebaseid} {...props}/>;
                break;
            case 'MyCalendar':case 'MeetingCalendar':    //会议日历元素 || 日历日程元素
                tab4Content=<Content_calendar ref={ebaseid} {...props}/>;
                break;
            case 'newNotice':   //公告元素预览
                tab4Content=<Content_newNotice ref={ebaseid} {...props}/>;
                break;
            case 'addwf':   //新建流程元素
                tab4Content=<Content_addWF ref={ebaseid} {...props}/>;
                break;
            case 'contacts':   //通讯录元素预览
                tab4Content=<Content_contacts ref={ebaseid} {...props}/>;
                break;
            case 'scratchpad':   //便签元素预览
                tab4Content=<Content_scratchpad ref={ebaseid} {...props}/>;
                break;
            case 'weather':   //天气元素预览
                tab4Content=<Content_weather ref={ebaseid} {...props}/>;
                break;
            case 'video':   //视频元素预览
                tab4Content=<Content_video ref={ebaseid} {...props}/>;
                break;
            case 'audio':   //音频元素预览
                tab4Content=<Content_audio ref={ebaseid} {...props}/>;
                break;
            case 'searchengine':   //搜索元素预览
                tab4Content=<Content_searchengine ref={ebaseid} {...props}/>;
                break;
            case 'blogStatus':   //微博元素预览
                tab4Content=<Content_blogStatus ref={ebaseid} {...props}/>;
                break;
            case 'Task':   //任务元素预览
                tab4Content=<Content_task ref={ebaseid} {...props}/>;
                break;
            case '16':   //我的邮件元素预览
                tab4Content=<Content_16 ref={ebaseid} {...props}/>;
                break;
            case '19':   //股票元素预览
                tab4Content=<Content_19 ref={ebaseid} {...props}/>;
                break;
            case '25':   //文档内容元素预览
                tab4Content=<Content_25 ref={ebaseid} {...props}/>;
                break;
            case 'Flash':   //文档内容元素预览
                tab4Content=<Content_flash ref={ebaseid} {...props}/>;
                break;
            default:    //列表元素预览
                tab4Content=<Content_7 ref={ebaseid} {...props}/>;
        }
        return tab4Content;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
WeaElementPreview = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(WeaElementPreview);
export default WeaElementPreview;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/index.js